import { render, staticRenderFns } from "./PopAddSplits.vue?vue&type=template&id=6000a434&scoped=true&"
import script from "./PopAddSplits.vue?vue&type=script&lang=js&"
export * from "./PopAddSplits.vue?vue&type=script&lang=js&"
import style0 from "./PopAddSplits.vue?vue&type=style&index=0&id=6000a434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6000a434",
  null
  
)

export default component.exports